// example
export const systemName = state => state.common.systemName
export const userInfo = state => state.common.userInfo
export const frontUserInfo = state => state.common.frontUserInfo
export const channelList = state => state.channel.channelList
export const currentChannel = state => state.channel.currentChannel
export const app = state => state.common.app
